<template>
  <div>
    <v-title>Add Contact</v-title>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
            <v-layout wrap>
              <v-flex sm4 md4 lg4>
                <!-- <v-text-field
                  v-model="contact.contactName"
                  label="Contact Name"
                  v-validate="'required'"
                  name="contactName"
                  :error-messages="errors.collect('contactName')"
                /> -->
                <vonex-text
                  ref="contactName"
                  v-model="contact.contactName"
                  name="contactName"
                  hint="Contact Name"
                  label="Contact Name"
                  :options="fieldConditions"
                  :rule="`required`"
                ></vonex-text>
              </v-flex>
              <v-flex sm4 md4 lg4>
                <!-- <v-text-field
                  v-if="delivery"
                  v-model="contact.contactMobile"
                  label="Phone Number"
                  v-validate="'required'"
                  name="contactMobile"
                  :error-messages="errors.collect('contactMobile')"
                /> -->
                <vonex-text
                  v-if="delivery"
                  ref="contactMobile"
                  v-model="contact.contactMobile"
                  name="contactMobile"
                  hint="Phone Number"
                  label="Phone Number"
                  :options="fieldConditions"
                  :rule="`required`"
                ></vonex-text>
                <vonex-text
                  v-else
                  ref="contactMobile"
                  v-model="contact.contactMobile"
                  name="contactMobile"
                  hint="Mobile"
                  label="Mobile"
                  :options="fieldConditions"
                  :rule="`required|mobilenumber`"
                ></vonex-text>
                <!-- <v-text-field
                  v-else
                  v-model="contact.contactMobile"
                  label="Mobile"
                  v-validate="'required|mobilenumber'"
                  name="contactMobile"
                  :error-messages="errors.collect('contactMobile')"
                /> -->
              </v-flex>
              <v-flex v-if="!delivery" sm4 md4 lg4>
                <vonex-text
                  ref="contactMobile"
                  v-model="contact.contactEmail"
                  name="contactEmail"
                  hint="Email"
                  label="contactEmail"
                  :options="fieldConditions"
                  :rule="delivery ? '' : 'required|email'"
                ></vonex-text>
                <!-- <v-text-field
                  v-model="contact.contactEmail"
                  label="Email"
                  :v-validate="delivery ? '' : 'required|email'"
                  name="contactEmail"
                  :error-messages="errors.collect('contactEmail')"
                /> -->
              </v-flex>
            </v-layout>
          </ValidationObserver>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeContact">Save</v-btn>
          <v-btn color="light-grey" @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Utils from '@/mixins/utils.mixin';
//@ts-check
export default {
  mixins: [Utils],
  props: ['delivery', 'contact'],
  data() {
    return {
      // contact: {
      //   contactID: 0,
      //   contactName: null,
      //   contactEmail: null,
      //   contactMobile: null
      // }
    };
  },
  methods: {
    cancel() {
      this.$emit('closeContact');
    },
    closeContact: function () {
      let vm = this;

      vm.$refs.observer.validate().then((result) => {
        if (result) {
          this.$emit('closeContact', this.contact);
        }
      });
    },
  },
};
</script>
